import { cn } from '@/lib/utils'

interface EmptyStateCardProps {
  /** CTA text when actionable ("Add a flight"), status text when not ("No flights") */
  label: string
  /** When provided, the whole card is a tap target; when absent, renders muted + non-interactive */
  onAdd?: () => void
  className?: string
}

/**
 * Dashed-border empty-state card for card sections in detail views and drawers.
 * The whole card is the add action; without onAdd it renders as a muted,
 * non-interactive placeholder.
 */
export function EmptyStateCard({ label, onAdd, className }: EmptyStateCardProps) {
  const cardClassName = cn(
    'flex w-full items-center justify-center rounded-2xl border border-dashed border-border-L3 p-3',
    className
  )

  if (onAdd) {
    return (
      <button type="button" onClick={onAdd} className={cn(cardClassName, 'active:opacity-70')}>
        <span className="flex h-9 items-center text-sm font-semibold text-content-brand-bold">
          {label}
        </span>
      </button>
    )
  }

  return (
    <div className={cardClassName}>
      <span className="flex h-9 items-center text-sm font-medium text-content-primary-subtle">
        {label}
      </span>
    </div>
  )
}
